<template>
  <ContentBox :title="'我的妮姬'" :normal-bg="'nikki_bg'">
    <template #header>
      <div class="header-btn">
        <el-input prefix-icon="el-icon-search" v-model="searchValue" v-if="isSearch" @input="handleSearch"></el-input>
        <img v-else src="@/assets/black_imgs/search.png" alt="" class="btn-img" @click="searchNikki"/>
        <img src="@/assets/black_imgs/filter.png" alt="" class="btn-img" v-popover:popover/>
      </div>
    </template>
    <div class="nikki">
      <div class="nikki-container">
        <div class="container-search">
          <div class="search-box" @click="toggleSort('level')">
            <div class="search-title" :class="{active: orderLevel.level}">等级</div>
            <img v-if="!orderLevel.level" src="@/assets/black_imgs/sort.png" alt=""
                 class="search-order"/>
            <img v-else src="@/assets/black_imgs/sort_active.png" alt="" class="search-order"
            />
          </div>
          <div class="search-box" @click="toggleSort('breakthrough')">
            <div class="search-title" :class="{active: orderLevel.breakthrough}">极限突破</div>
            <img v-if="!orderLevel.breakthrough" src="@/assets/black_imgs/sort.png" alt=""
                 class="search-order"/>
            <img v-else src="@/assets/black_imgs/sort_active.png" alt="" class="search-order"
            />
          </div>
          <div class="search-box" @click="toggleSort('rarity')">
            <div class="search-title" :class="{active: orderLevel.rarity}">稀有度</div>
            <img v-if="!orderLevel.rarity" src="@/assets/black_imgs/sort.png" alt=""
                 class="search-order"/>
            <img v-else src="@/assets/black_imgs/sort_active.png" alt="" class="search-order"
            />
          </div>
          <div class="search-box" @click="toggleSort('likability')">
            <div class="search-title" :class="{active: orderLevel.likability}">好感度</div>
            <img v-if="!orderLevel.likability" src="@/assets/black_imgs/sort.png" alt=""
                 class="search-order"/>
            <img v-else src="@/assets/black_imgs/sort_active.png" alt="" class="search-order"
            />
          </div>
        </div>
        <div class="nikki-group" id="nikki-group">
          <div class="group-list" v-for="(item, index) in cloneNikke" :key="index">
            <img :src="item.info.icon" alt="" class="nikki-img"/>
            <div class="bottom-content" v-if="item.isHaveNikki">
              <div class="stars-list">
                <img v-if="item.player_nikke.limit_break > 0" src="@/assets/black_imgs/stars_active.png"
                     alt="" class="stars-img"/>
                <img v-else src="@/assets/black_imgs/stars.png" alt="" class="stars-img"/>
                <img v-if="item.player_nikke.limit_break > 1" src="@/assets/black_imgs/stars_active.png"
                     alt="" class="stars-img"/>
                <img v-else src="@/assets/black_imgs/stars.png" alt="" class="stars-img"/>
                <img v-if="item.player_nikke.limit_break > 2" src="@/assets/black_imgs/stars_active.png"
                     alt="" class="stars-img"/>
                <img v-else src="@/assets/black_imgs/stars.png" alt="" class="stars-img"/>

                <div class="stars_bg" v-if="item.player_nikke.limit_break > 3">
                  <span :class="{max: item.player_nikke.limit_break - 3}">
                    {{ item.player_nikke.limit_break - 3 > 6 ? 'max' : item.player_nikke.limit_break - 3 }}
                  </span>
                </div>
              </div>
              <div class="nikki-level">
                <div class="nikki-text">LV.</div>
                <div class="nikki-num">{{ item.player_nikke.level || 0 }}</div>
              </div>
              <div class="nikki-name"><TextSlider :text="item.info.name" :duration="20" /></div>
              <div class="black_line"></div>
            </div>
            <div class="lock" v-else>
              <div class="lock-box-yellow"></div>
              <div class="lock-model"></div>
              <div class="lock-name-img">
                <img src="@/assets/black_imgs/lock_icon.png" alt="" class="lock_img" />
                <div class="lock_name">
                  {{ item.info.name }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--筛选-->
      <el-popover
        placement="left-start"
        ref="popover"
        width="640"
        popper-class="custom-popover"
        :append-to-body="false"
        trigger="click">
        <div class="popover-content">
          <div class="list-header">
            <div class="list-header-common">
              <div class="list-header-common-title">超标准</div>
              <div class="list-header-common-desc">
                <div class="desc-item" :class="{active: searchList.includes('超标准')}" @click="handleSelect('超标准')">
                  超标准
                </div>
              </div>
            </div>
            <div class="list-header-common">
              <div class="list-header-common-title">妮姬</div>
              <div class="list-header-common-desc">
                <div class="desc-item" :class="{active: searchList.includes('所有妮姬')}"
                     @click="handleSelect('所有妮姬')">所有妮姬
                </div>
                <div class="desc-item" :class="{active: searchList.includes('已获得妮姬')}"
                     @click="handleSelect('已获得妮姬')">已获得妮姬
                </div>
              </div>
            </div>
          </div>
          <div class="list-common">
            <div class="list-common-title">阶段</div>
            <div class="list-common-group">
              <div class="list-common-item" :class="{active: filterList.jd.includes(item.name)}"
                   v-for="item in entryFilter && entryFilter[1].children || []" :key="item.id"
                   @click="handleSelect(item.name, 'jd')">{{
                  item.name
                }}
              </div>
            </div>
          </div>
          <div class="list-common">
            <div class="list-common-title">企业</div>
            <div class="list-common-group">
              <div class="list-common-item" :class="{active: filterList.qy.includes(item.name)}"
                   v-for="item in entryFilter && entryFilter[0].children || []" :key="item.id"
                   @click="handleSelect(item.name, 'qy')">{{
                  item.name
                }}
              </div>
            </div>
          </div>
          <div class="list-common">
            <div class="list-common-title">属性</div>
            <div class="list-common-group">
              <div class="list-common-item" :class="{active: filterList.attr.includes(item.name)}"
                   v-for="item in entryFilter && entryFilter[4].children || []" :key="item.id"
                   @click="handleSelect(item.name, 'attr')">{{
                  item.name
                }}
              </div>
            </div>
          </div>
          <div class="list-header mt10">
            <div class="list-header-common">
              <div class="list-header-common-title">职业</div>
              <div class="list-header-common-desc">
                <div class="desc-item" :class="{active: filterList.zy.includes(item.name)}"
                     v-for="item in entryFilter && entryFilter[5].children || []" :key="item.id"
                     @click="handleSelect(item.name, 'zy')">
                  {{ item.name }}
                </div>
              </div>
            </div>
            <div class="list-header-common">
              <div class="list-header-common-title">稀有度</div>
              <div class="list-header-common-desc">
                <div class="desc-item" :class="{active: filterList.level.includes(item.name)}"
                     v-for="item in entryFilter && entryFilter[3].children || []" :key="item.id"
                     @click="handleSelect(item.name, 'level')">
                  {{ item.name }}
                </div>
              </div>
            </div>
          </div>
          <div class="list-common">
            <div class="list-common-title">武器</div>
            <div class="list-common-group">
              <div class="list-common-item" :class="{active: filterList.wq.includes(item.name)}"
                   v-for="item in entryFilter && entryFilter[2].children || []" :key="item.id"
                   @click="handleSelect(item.name, 'wq')">{{
                  item.name
                }}
              </div>
            </div>
          </div>
          <div class="btn-box">
            <div class="btn reset" @click="resetSorting">重置</div>
            <div class="btn filter" @click="processNikkiList">筛选</div>
          </div>
        </div>
      </el-popover>
    </div>
  </ContentBox>
</template>
<script>
// components
import ContentBox from "./ContentBox.vue"
import TextSlider from "@/components/TextSlider";
// utils
import { deepClone, debounce } from "@/plugins/util"

export default {
  name: "Nikki",
  props: {
    nikkiList: {
      type: Array,
      default: () => []
    },
    entryFilter: {
      type: Array,
      default: () => []
    }
  },
  components: {
    ContentBox,
    TextSlider
  },
  data() {
    return {
      searchValue: "",
      cloneListL: [], // 原始数据列表
      originalOrder: [], // 保存原始顺序
      isSearch: false,
      drawer: false,
      orderLevel: {
        level: false, // 等级
        breakthrough: false, // 极限突破
        rarity: false, // 稀有度
        likability: false // 好感度
      },
      filterList: {
        jd: [],
        qy: [],
        attr: [],
        zy: [],
        level: [],
        wq: []
      }, // 筛选字段
      cloneNikke: [],
      searchList: [], // 筛选字段
      rarityList: ['SSR', 'SR', 'R'], // 稀有度排序数组
      changeNikkiList: []
    }
  },
  watch: {
    nikkiList: {
      deep: true,
      immediate: true,
      handler(val) {
        if (val) {
          const cloneList = deepClone(val);
          this.changeNikkiList = cloneList.map(item => {
            return {
              info: { ...item.info },
              player_nikke: {
                ...item.player_nikke,
                levelText: item.info.level
              },
              isHaveNikki: item.player_nikke.costume_id !== 0
            };
          });
          this.cloneNikke = deepClone(this.changeNikkiList);
          this.processNikkiList();
        }
      },
    }
  },
  mounted() {
    if (this.changeNikkiList.length > 0) {
      this.cloneNikke = deepClone(this.changeNikkiList)
      this.cloneNikke = this.cloneNikke.map(item => {
        return {
          info: { ...item.info },
          player_nikke: {
            ...item.player_nikke,
            levelText: item.info.level,
            limit_break: 10
          }
        }
      })
      this.processNikkiList()
    }
  },
  methods: {
    searchNikki() {
      this.isSearch = true
    },
    handleClose() {
      this.drawer = false
    },
    handleSearch: debounce(function () {
      console.log(this.searchValue)
      this.cloneNikke = this.changeNikkiList.filter(item => {
        return item.info.name.includes(this.searchValue)
      })
    }),
    handleSelect(filterText, type) {
      if (type) {
        const index = this.filterList[type].findIndex(item => item === filterText)
        if (index === -1) {
          this.filterList[type].push(filterText)
        } else {
          this.filterList[type].splice(index, 1)
        }
      } else {
        const index = this.searchList.findIndex(item => item === filterText)
        if (index === -1) {
          this.searchList.push(filterText)
        } else {
          this.searchList.splice(index, 1)
        }
      }
    },
    processNikkiList() {
      // 1、过滤
      this.filterNikki()

      // 2. 执行排序
      this.applySorting()

      this.$emit("asyncShareInfo", this.cloneNikke)

      this.$refs.popover && this.$refs.popover.doClose()
    },
    filterNikki() {
      const specialFilters = new Set(["所有妮姬", "已获得妮姬", "超标准"]);
      const conditions1 = this.searchList.filter(f => ["所有妮姬", "已获得妮姬"].includes(f));
      const conditions2 = this.searchList.filter(f => !specialFilters.has(f));
      const hasSuperStandard = this.searchList.includes("超标准");

      this.cloneNikke = this.changeNikkiList.filter(item => {
        // 条件1：必须满足所有条件1
        const meetCondition1 = conditions1.every(cond => {
          if (cond === "所有妮姬") return true;
          if (cond === "已获得妮姬") return item.isHaveNikki;
          return false;
        });

        // 条件2：filterList[key]属性并集，key属性交集
        const meetCondition2 = Object.keys(this.filterList)
          .filter(key => this.filterList[key].length > 0) // 只处理有筛选值的key
          .every(key => {
            // 同一个key下的筛选值之间是"或"关系（并集）
            return this.filterList[key].length === 0 ||
                   this.filterList[key].some(filterValue =>
                       String(item.info[key]) === String(filterValue)
                   );
          });

        // 综合条件1和条件2
        let finalMatch = meetCondition1 && meetCondition2;

        // 额外处理超标准条件
        if (hasSuperStandard && finalMatch) {
          finalMatch = item.info.qy.includes("超标准");
        }

        return finalMatch;
      });
      this.drawer = false;
    },
    // 排序
    applySorting() {
      const tempList = deepClone(this.cloneNikke);

      // 如果没有集合任何排序条件，回恢复原始顺序
      if (!Object.values(this.orderLevel).some(v => v)) {
        this.cloneNikke = tempList;
        return;
      }
      // 创建排序后的副本
      const sortedList = [...this.cloneNikke];
      // 符合排序
      sortedList.sort((a, b) => {
        // 1、等级排序
        if (this.orderLevel.level) {
          const levelDiff = b.player_nikke.level - a.player_nikke.level;
          if (levelDiff !== 0) return levelDiff;
        }
        // 2、极限突破排序
        if (this.orderLevel.breakthrough) {
          const breakthroughDiff = b.player_nikke.limit_break - a.player_nikke.limit_break;
          if (breakthroughDiff !== 0) return breakthroughDiff;
        }

        // 3、稀有度排序
        if (this.orderLevel.rarity) {
          const aRarityIndex = this.rarityList.indexOf(a.player_nikke.levelText);
          const bRarityIndex = this.rarityList.indexOf(b.player_nikke.levelText);
          const rarityDiff = aRarityIndex - bRarityIndex;
          if (rarityDiff !== 0) return rarityDiff;
        }
        // 4、好感度排序
        if (this.orderLevel.likability) {
          const likabilityDiff = b.player_nikke.attractive_level - a.player_nikke.attractive_level;
          if (likabilityDiff !== 0) return likabilityDiff;
        }
        // 如果所有激活的排序条件都相同，保持原顺序
        return 0;
      });
      this.cloneNikke = sortedList;
    },
    // 切换排序状态
    toggleSort(type) {
      // 切换排序状态
      this.orderLevel[type] = !this.orderLevel[type]
      this.processNikkiList()
    },
    // 重置排序
    resetSorting() {
      Object.keys(this.orderLevel).forEach(key => {
        if (key === "breakthrough") {
          this.orderLevel[key] = true;
        } else {
          this.orderLevel[key] = false;
        }
      })
      this.searchList = []
      this.searchValue = ""
      this.cloneNikke = deepClone(this.changeNikkiList)
      this.$refs.popover.doClose()
    },
  }
}
</script>
<style scoped lang="less">
.container-search {
  width: 100%;
  height: 22px;
  display: flex;
  padding: 17px 0;
  gap: 10px;

  .search-box {
    display: flex;
    align-items: center;
    height: 100%;
    gap: 4px;

    .search-title {
      font-weight: 400;
      font-size: 12px;
      color: #a8a8a8;
      cursor: pointer;

      &.active {
        font-weight: 500;
        font-size: 12px;
        color: #111111;
        text-decoration: underline;
      }
    }

    .search-order {
      width: 10px;
      height: 10px;
      cursor: pointer;
    }
  }
}

.nikki {
  height: 465px;
  margin-bottom: 10px;
  border-radius: 0 0 10px 10px;

  .nikki-container {
    width: 100%;
    height: 465px;
    overflow-y: auto;
    padding: 0 14px;
    background: #fafbfc;
    border-radius: 0 0 10px 10px;

    .nikki-group {
      width: 100%;
      display: grid;
      grid-template-columns: repeat(5, 1fr);
      gap: 8px;
      padding-bottom: 10px;

      .group-list {
        position: relative;
        width: 100%;
        height: 170px;

        .nikki-img {
          width: 100%;
          height: 100%;
        }

        .bottom-content {
          width: 100%;
          height: 50px;
          position: absolute;
          left: 0;
          bottom: 0;

          .nikki-level {
            position: absolute;
            left: 2px;
            bottom: 2px;

            .nikki-text {
              font-weight: bold;
              font-size: 14px;
              color: #FFFFFF;
              line-height: 12px;
            }

            .nikki-num {
              font-weight: bold;
              font-size: 16px;
              color: #FFFFFF;
              line-height: 24px;
              text-shadow: 1px 0 0 #464646;
              -webkit-text-stroke: 1px #464646;
            }
          }

          .nikki-name {
            position: absolute;
            font-weight: bold;
            height: 32px;
            font-size: 14px;
            color: #FFFFFF;
            width: 80px;
            right: 5px;
            bottom: 3px;
            overflow: hidden; /* 隐藏溢出的内容 */
            white-space: nowrap; /* 禁止文本换行 */
            text-overflow: ellipsis; /* 使用省略号表示溢出的文本 */
            display: flex;
            justify-content: flex-end;
            align-items: center;
          }

          .black_line {
            position: absolute;
            right: 0;
            bottom: 0;
            width: 59px;
            height: 9px;
            background: url("~@/assets/black_imgs/nikki_img_bg.png") no-repeat;
            background-size: 100% 100%;
          }

          .stars-list {
            position: absolute;
            right: 2px;
            top: 0;
            display: flex;

            .stars-img {
              width: 18px;
              height: 18px;
            }

            .stars_bg {
              width: 20px;
              height: 18px;
              background: url("~@/assets/black_imgs/breakThrough_bg.png") no-repeat;
              background-size: 100% 100%;
              display: flex;
              justify-content: center;
              align-items: center;
              font-size: 12px;
              color: #FFFFFF;
              text-wrap: nowrap;

              .max {
                transform: scale(0.6);
              }
            }
          }
        }

        .lock {
          width: inherit;
          height: inherit;
          position: absolute;
          bottom: 0;
          left: 0;

          .lock-box-yellow {
            width: inherit;
            position: absolute;
            bottom: 0;
            left: 0;
            display: flex;
            justify-content: center;
            background: #f9d123;
            height: 55px;
            z-index: 1;
          }

          .lock-model {
            width: inherit;
            height: inherit;
            position: absolute;
            background: rgba(0, 0, 0, 0.15);
            z-index: 2;
          }

          .lock-name-img {
            width: 100%;
            height: 55px;
            position: absolute;
            left: 0;
            bottom: 0;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            gap: 8px;

            z-index: 3;
            .lock_img {
              width: 20px;
              height: 20px;
            }

            .lock_name {
              text-align: center;
              width: 80%;
              color: rgba(255, 255, 255);
              overflow: hidden; /* 隐藏溢出的内容 */
              white-space: nowrap; /* 禁止文本换行 */
              text-overflow: ellipsis; /* 使用省略号表示溢出的文本 */
              display: flex;
              align-items: flex-end;
              justify-content: center;
            }
          }
        }
      }
    }
  }

  /deep/ .custom-popover {
    width: 100%;

    .popover-content {
      width: calc(100% - 20px);
      margin: 0 auto;

      .mt10 {
        margin-top: 10px;
      }

      .list-header {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 8px;

        .list-header-common {
          display: flex;
          flex-direction: column;
          gap: 8px;
          width: 100%;

          .list-header-common-title {
            font-weight: bold;
            font-size: 18px;
            color: #333333;
          }

          .list-header-common-desc {
            display: flex;
            gap: 10px;

            .desc-item {
              width: 90px;
              height: 34px;
              background: #E5E5E5;
              border-radius: 2px;
              font-weight: 400;
              font-size: 14px;
              color: #333333;
              display: flex;
              justify-content: center;
              align-items: center;
              cursor: pointer;

              &.active {
                background: #E0F2FE;
                color: #3490E6;
              }
            }
          }
        }
      }

      .list-common {
        margin-top: 10px;
        display: flex;
        flex-direction: column;
        width: 100%;
        gap: 8px;

        .list-common-title {
          font-weight: bold;
          font-size: 18px;
          color: #333333;
        }

        .list-common-group {
          display: flex;
          gap: 10px;
          flex-wrap: wrap;
          width: 100%;

          .list-common-item {
            width: 90px;
            height: 34px;
            background: #E5E5E5;
            border-radius: 2px;
            font-weight: 400;
            font-size: 14px;
            color: #333333;
            display: flex;
            justify-content: center;
            align-items: center;
            flex-shrink: 0;
            cursor: pointer;

            &.active {
              background: #E0F2FE;
              color: #3490E6;
            }
          }
        }
      }

      .btn-box {
        margin-top: 15px;
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 8px;

        .btn {
          width: 289px;
          height: 43px;
          border-radius: 50px;
          font-weight: 600;
          font-size: 16px;
          color: #3490E6;
          display: flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;
        }

        .reset {
          border: 1px solid #3490E6;
          color: #3490E6;
        }

        .filter {
          background: #3490E6;
          color: #FFFFFF;
        }
      }
    }
  }

}

/deep/ .header-btn {
  display: flex;
  align-items: center;

  .el-input {
    width: 156px;
    height: 24px;
    background: rgba(255, 255, 255, 0.15);
    border-radius: 10px;
    margin-right: 8px;

    .el-input__inner {
      width: inherit !important;
      height: inherit !important;
    }

    .el-input__prefix {
      position: absolute !important;
      top: -4px !important;
    }
  }

  .btn-img {
    width: 18px;
    height: 18px;
    margin-right: 14px;
  }
}

/deep/ .el-drawer {
  height: 400px !important;
  box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.15);
  border-radius: 16px 16px 0 0;

  .el-drawer__body {
    box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.15);
    border-radius: 16px 16px 0 0;
  }
}
</style>
<style>

</style>
